import * as actionTypes from 'ActionTypes';
import { updateObj } from 'Utils';

const initialState = {
	isOpen: false
};

export const SidebarReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_SIDEBAR:
			return updateObj(state, { isOpen: action.isOpen });
		default:
			return state;
	}
};
